// extracted by mini-css-extract-plugin
module.exports = {"FormHeader":"styles_FormHeader__338Pj","FormInput":"styles_FormInput__22C4Z","FormButton":"styles_FormButton__237SY","Step2":"styles_Step2__1DjMo"};